module.exports = __webpack_public_path__ + "img/Compliance New.3728f66a.svg";